import React,{ PureComponent }  from 'react'
import Module1 from './components/Module1'
import Module2 from './components/Module2'
import Module3 from './components/Module3'
import Module4 from './components/Module4'
import './list.css'
import { data } from './listData'

class Page extends PureComponent {
    constructor(props){
        super(props)
        this.state={
            moduleData:{
                module1:{},
                module2:[],
                module3:{},
                module4:{}
            }
        }
    }
    componentWillReceiveProps(nextProps){
        const id = nextProps.match.params.id;
        this.setState({
            moduleData: data[id]
        })
    }
    componentDidMount(){
        const id = this.props.match.params.id;
        this.setState({
            moduleData: data[id]
        })
    }
    render(){
        const { module1,module2,module3,module4} = this.state.moduleData
        return(
            <article>
                <Module1 { ...module1 } />
                <Module2 data={ module2 }/>
                <Module3 {...module3 } />
                <Module4 {...module4 } />
            </article>
        )
    }
    
}
export default Page